type Period = 'initial' | 'recurring'

/**
 * Calculate prices from a Priceable or list of Priceables. If an array is provided, the cheapest price will be returned.
 *
 * @param items - A Priceable or a list of Priceables
 * @param period - 'initial' or 'recurring', depending on for which period you want to get prices for. Defaults to 'initial'
 */
export function usePrices(
  items: MaybeRefOrGetter<Priceable>,
  period?: Period,
): ComputedRef<CalculatedPrices>
export function usePrices(
  items: MaybeRefOrGetter<undefined>,
  period?: Period,
): ComputedRef<null>
export function usePrices(
  items: MaybeRefOrGetter<undefined | Priceable | Priceable[]>,
  period?: Period,
): ComputedRef<CalculatedPrices | null>
export function usePrices(
  item: MaybeRefOrGetter<Priceable | Priceable[] | undefined>,
  period: Period = 'initial',
): ComputedRef<CalculatedPrices | null> {
  const totStudents = useTotStudents()

  const auth = useAuthorizeStore()

  return computed(() => {
    const value = toValue(item)

    if (!value) {
      return null
    }

    const items = Array.isArray(value) ? value : [value]

    return items.reduce<CalculatedPrices | null>((min, item) => {
      const current = calculatePrices(
        item,
        totStudents.value,
        auth.user?.source,
        period,
      )

      if (
        !min ||
        min === 'NOT_APPLICABLE' ||
        (current !== 'NOT_APPLICABLE' &&
          current.actual.exVat < min.actual.exVat)
      ) {
        return current
      }

      return min
    }, null)
  })
}
